import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'registro-servizi',
  titolo: 'Registro dei servizi erogati',
  gruppo: 'Rete e progetti',
  permesso: 'servizio_erogato.leggi',
  aCheServe: 'Il registro raccoglie i servizi che CIDIS rende agli enti (e quelli interni a CIDIS): una '
    + 'mediazione in ospedale, una formazione agli operatori di un comune.',
  parti: [
    {
      titolo: 'Registrare un servizio',
      permesso: 'servizio_erogato.registra',
      passi: [
        'Apri «Registro dei servizi erogati» e premi «Registra un servizio».',
        'In «Ente e servizio» scegli l’ente (oppure «— nessuno: servizio interno a CIDIS —»), il referente, il '
          + 'dipartimento e la «Tipologia».',
        'In «Quando, dove, per quale progetto» indica data, ore, modalità, «Sede CIDIS» e progetto.',
        'Per una mediazione scegli mediatore e lingua: le ore vanno a mezz’ore.',
        'Se qualche dato va confermato, spunta «Da verificare» e scrivi il motivo.',
        'Premi «Registra il servizio».',
      ],
      nota: 'Senza beneficiario la descrizione non è cifrata: non scrivere dati personali.',
    },
    {
      titolo: 'Verificare e correggere',
      testo: [
        'I servizi «da verificare» compaiono anche nel Cruscotto. Nel dettaglio del servizio, chi può modificarlo '
          + 'trova «Conferma la verifica», «Modifica» e «Annulla il servizio» (con il motivo).',
        'La linguetta «Riepilogo per tipologia» conta servizi, ore ed enti per tipologia.',
      ],
    },
  ],
  avvertenze: [
    {
      quando: '«Con i tuoi incarichi non puoi registrare servizi nella sede «…».»',
      cosaFare: 'Scegli una delle sedi indicate nel campo «Sede CIDIS». Se il servizio è di un’altra sede, '
        + 'chiedi a un collega di quella sede.',
    },
  ],
  vediAnche: ['enti', 'progetti'],
  parole: ['servizi', 'erogati', 'registro', 'ente', 'ore', 'verifica'],
}

export default capitolo
